import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField  from "../../../../../../ui/TextField";

const useStyles = makeStyles({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    },
    "& .MuiGrid-spacing-xs-4 > .MuiGrid-item": {
      paddingTop: 4,
      paddingBottom: 32
    }
  },
  mainGrid:{
    marginTop: 8
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  block: {
    margin: "35px 0 15px 0"
  },
  blockrow: {
    marginTop: 16
  },
});

const SkillEditStaff = ({onFormChange, teacherLevel, teacherStage, teacherProf, teacherExtra}) => {
  const classes = useStyles();
  const initialData = {
    teacherLevel: teacherLevel || '',
    teacherStage: teacherStage || '',
    teacherProf: teacherProf || '',
    teacherExtra: teacherExtra || ''};
  const [data, setData] = React.useState(initialData);

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  return (
      <div className={classes.root}>
      <Typography className={classes.heading}>Требования к квалификации педагогического состава</Typography>
      <Grid container spacing={2} className={classes.mainGrid}>
        <Grid item xs={12} md={6}>
          <TextField
            value={teacherLevel}
            label='Уровень образования'
            onChange={(e) =>  onChange("teacherLevel", e.target.value)}
          />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
                value={teacherProf}
                label='Квалификация'
                onChange={(e) =>  onChange("teacherProf", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
                value={teacherStage}
                label='Опыт работы'
                onChange={(e) =>  onChange("teacherStage", e.target.value)}
            />
            </Grid>
            <Grid item xs={12}>
              <TextField
                  multiline
                  value={teacherExtra}
                  label='Дополнительно'
                  onChange={(e) =>  onChange("teacherExtra", e.target.value)}
              />
            </Grid>
          </Grid>
      </div>
  );
};

export default SkillEditStaff;
